module.exports = __webpack_public_path__ + "static/ModernEra-Regular-c914c198616aec227b80c181da810b35.woff";